<div class="flex flex-col rounded-xl px-0 pb-0 pt-2 md:py-4">
  <div>Primary Reporter</div>
  <div class="flex justify-start pt-2">
    <div
      class="mr-2.5 h-7 w-7 overflow-hidden rounded-full border border-blue-950 transition-[border] duration-300 ease-in-out hover:border-orange-500"
    >
      <span>
        <img
          class="pointer-events-none max-h-full max-w-full"
          alt="Reporter icon"
          src="assets/images/icons_legacy/img_user_default@2x.png"
        />
      </span>
    </div>

    <div>
      <div class="flex pb-2 text-base leading-4">
        {{ ticket.Contact.Name | titlecase }}
        @if (ticket.Contact.Title) {
          <span
            class="ml-2 border-l border-[color:var(--black-blue)] pl-2 text-xs italic"
          >
            {{ ticket.Contact.Title | titlecase }}
          </span>
        }
      </div>
      <div class="leading-2 flex items-center text-sm">
        <mat-icon class="text-sm">call</mat-icon>
        {{
          ticket.Contact.Phone !== null
            ? (ticket.Contact.Phone | phoneNumber: 'US')
            : 'N/A'
        }}
      </div>

      <div class="leading-2 flex items-center text-sm">
        <mat-icon class="text-sm">mail</mat-icon>
        {{ (ticket.Contact.Email | lowercase) || 'N/A' }}
      </div>
    </div>
  </div>
</div>
